import { Component, HostListener, Input, OnInit, ViewChild } from "@angular/core"
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser"

@Component({
    selector: "app-bento-page",
    templateUrl: "./bento.component.html",
    styleUrls: ["./bento.component.scss"],
})
export class BentoComponent implements OnInit {
    @Input() componentClasses: string = ""
    @Input() set bentoLink(link: string) {
        if (link) {
            this._bentoLink = link
            this._bentoLinkSafe = this.sanitizer.bypassSecurityTrustResourceUrl(link)
        } else {
            this._bentoLink = null
        }
    }
    loading: boolean = true
    _bentoLinkSafe: SafeResourceUrl = ""
    _bentoLink: string = ""

    @HostListener("window: message", ["$event"])
    listenToIframe(event) {
        if (this._bentoLink.includes(event.origin)) {
            document.getElementById("bento-iframe").style.height = event.data + "px"
            this.loading = false
        }
    }

    constructor(public sanitizer: DomSanitizer) {}

    ngOnInit() {}
}
